import bem from 'utils/bem';

export const block = bem('youtube-most-replayed-upsell-modal');
